import { render } from "./AddQuestionPage.vue?vue&type=template&id=05e879e6&ts=true"
import script from "./AddQuestionPage.vue?vue&type=script&lang=ts"
export * from "./AddQuestionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__